import React from 'react';
import styled from 'styled-components';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

const TableHead = styled.thead`
  background-color: #f4f4f4;
`;

const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  font-Size:15px;
`;

const TableRow = styled.tr`
  &:nth-of-type(even) {
    background-color: #f9f9f9;
  }

  &:hover {
    background-color: #f1f1f1;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size:13px;
`;

const TableContainer = styled.div`
  border-radius: 5px;
  overflow: hidden;
`;

const OrderSummaryTable = ({ items }) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>Name</TableHeaderCell>
            <TableHeaderCell>Product</TableHeaderCell>
          </TableRow>
        </TableHead>
        <tbody>
          {items.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.cItem_Description}</TableCell>
              <TableCell>{item.cProduct_Type}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
};

export default OrderSummaryTable;
